import {
    GET_CONFIG_MESSAGES,
    RE_LOADING,
    ADD_CONFIG_MESSAGES
  } from "../actions/ConfigurationMessagesAction";
  
  
  const initialState = {
    configMessage: [],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case RE_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_CONFIG_MESSAGES: {
            return{
                ...state,
                configMessage : [...action.data],
                loading: false,
                add : false,
            }
        }
        case ADD_CONFIG_MESSAGES: {
          return {
            ...state,
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  